import React from 'react';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';

type RegionNoteFormHeaderProps = {
  goBack: () => void;
  onCloseModal: () => void;
};

export const RegionNoteFormHeader = ({ goBack, onCloseModal }: RegionNoteFormHeaderProps) => (
    <div className={styles.regionNoteModalHeader}>
      <Icon
        className={styles.buttonBack}
        glyph={Icon.set.ARROW_BACK}
        onClick={goBack}
        testId="region-note-form-button-back"
      />
      {getMessage('regionNote.form')}
      <Icon
        className={styles.closeModal}
        glyph={Icon.set.REMOVE}
        onClick={onCloseModal}
        testId='region-note-form-close-Icon'
      />
    </div>
  );
